import { COLOR } from '@cosuno/cosuno-ui';
import styled from 'styled-components';

import { UpsellSuccessCallout } from '../UpsellSuccessCallout';

export const StyledUpsellSuccessCallout = styled(UpsellSuccessCallout)`
  color: ${COLOR.success};
`;
